export default function DownloadCTASection() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20gradient%20background%20with%20emerald%20green%20and%20gold%20light%20streaks%2C%20smooth%20flowing%20lines%2C%20luxurious%20gaming%20atmosphere%2C%20modern%20minimalist%2C%20dramatic%20lighting%20effects&width=1920&height=600&seq=cta-bg-ng-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-white mb-4">
          准备好开始游戏了吗？
        </h2>
        <p className="text-sm text-white/70 mb-8 max-w-lg mx-auto">
          立即下载NG南宫官方正版APP，海量游戏等你来玩，安全极速，一键安装
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#download"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-cloud-2-line text-lg"></i>
            <span>立即下载 NG南宫</span>
          </a>
          <a
            href="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </a>
        </div>
      </div>
    </section>
  );
}